







































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import vuetifyToast from "vuetify-toast";
import { Passenger } from "@/components/Passenger/models/Passenger";
import PassengerDetailsEditor from "@/components/Passenger/components/PassengerDetailsEditor.vue";
import PassengerUtilities from "@/components/Passenger/components/PassengerUtilities.vue";

@Component({
  components: {
    PassengerUtilities,
    PassengerDetailsEditor,
  },
})
export default class OrganizationPassengerPage extends Vue {
  public static NEW_GROUP_CREATOR_ITEM: string = "- New group -";

  allowUserInput = true;

  valid: boolean = true;
  saving: boolean = false;
  rules: any = {
    required: (value) =>
      !!value || this.$i18n.translate("validation.rules.required", "Required"),
  };
  inactivating: boolean = false;
  deleting: boolean = false;

  @Prop({ default: null }) private editedPassenger!: Passenger | null;
  @Prop() private passengerGroupId!: string;


  closeDialog() {
    this.$emit('closeDialog')
  }

  async onSaveClick(fromPhoneNumberEditorClick: boolean) {
    // TODO: Get rid of casting to any
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    
    this.saving = true;
    try {
      const newPassengerGroupPassengerRequest = {
        passenger: this.editedPassenger,
        passengerGroupId: this.passengerGroupId,
      };
      if (this.editedPassenger.id > 0) {
        await this.modifyPassenger(newPassengerGroupPassengerRequest);
      } else {
        await this.createPassenger(newPassengerGroupPassengerRequest);
      }
      vuetifyToast.success(this.$i18n.translate("passenger.save.success", "Passenger saved successfully."));
      if (!fromPhoneNumberEditorClick) {
        this.closeDialog();
      }
    } catch (error) {
      vuetifyToast.error(this.$i18n.translate("passenger.save.error.generic", "There was an error saving the passenger. Please try again later."));
    }
    this.saving = false;
  }

  async modifyPassenger(request: any) {
    const result = await this.$store.dispatch(
      "organization/modifyPassengerGroupPassenger", {
        params: { id: this.passengerGroupId },
        data: request,
      }
    );
    this.$store.dispatch('passenger/replacePassenger', new Passenger(result.data));
    return result;
  }

  async createPassenger(request: any) {
    const result = await this.$store.dispatch(
      "organization/createPassengerGroupPassenger",
      {
        params: { id: this.passengerGroupId },
        data: request,
      }
    );
    // this.passenger = new Passenger(result.data);
    this.$store.dispatch("passenger/addPassenger", new Passenger(result.data));
    return result;
  }

}
